import React from "react";

export default function Class3Message(props) {
    return (
        <div className="bg-city-green-light border-t border-b border-city-green-dark/70 text-city-green-dark px-4 py-3">
            <p className="font-bold">{props.address ? `Abated Property: ${props.address}` : `Abated Property`}</p>
            <p className="text-sm">
                This property has a tax abatement. For more information on how properties with tax abatements would be impacted please visit the <a className="font-bold underline" href='https://detroitmi.gov/departments/office-chief-financial-officer/land-value-tax-plan#lvtp' target="_blank" rel="noopener noreferrer">website</a>.
            </p>
        </div>
    )
}